module.exports = __webpack_public_path__ + "img/location.34f3a25c.svg";